import posthog from "posthog-js";
import { config } from "@/lib/config";

export const FEATURE_FLAGS = {
  UPGRADE_FLOW: "upgrade-flow",
  NEWSLETTER_SIGNUP: "newsletter-signup",
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

const ENV_OVERRIDE_KEYS = {
  UPGRADE_FLOW: "FF_UPGRADE_FLOW",
  NEWSLETTER_SIGNUP: "FF_NEWSLETTER_SIGNUP",
} as const satisfies Record<FeatureFlagKey, keyof typeof config>;

export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  const envOverride = config[ENV_OVERRIDE_KEYS[flag]];

  if (envOverride === "true") return true;
  if (envOverride === "false") return false;

  return posthog.isFeatureEnabled(FEATURE_FLAGS[flag]) === true;
}
